import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import performRiskAssessmentDialog from '../dialog.performRiskAssessmentDialog';
import controller from './confirm-begin-risk-assessment-dialog.controller';
import template from './confirm-begin-risk-assessment-dialog.html';


class dialogService {
  getOptions($event, { vendor, product }) {
    return {
      controller,
      controllerAs: 'confirmBeginRiskAssessmentDialogVM',
      locals: {
        vendor,
        product,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.confirmBeginRiskAssessmentDialog', [
  constants,
  loaderService,
  ssDialogService,
  vmDataService,
  performRiskAssessmentDialog,
])
  .service('confirmBeginRiskAssessmentDialog', dialogService)
  .name;
